import { LandingLayout } from 'layouts';
import { GoogleReCaptchaProvider } from 'lib/react-google-recaptcha-v3';
import { useLocation } from 'react-router';
import { AxiosErrorBoundary } from 'ui';
import { ContentLeft, Footer, Header, type HeaderItem, SignUp } from 'features/onboarding';
import { useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type SignUpLocationState = OnboardingLocationState;

const PageSignUp = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: SignUpLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToCheckCode, onNavigateToPrimaryLogin } = useOnboardingNavigation<SignUpLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessSignUp } = useOnSuccessLogin<SignUpLocationState>();

  const [path, search] = state?.referrer?.split('?') ?? [];
  const invitationToken = new URLSearchParams(search).get('invitation_token') ?? undefined;
  const changeRequestId = new URLSearchParams(search).get('chr') ?? undefined;
  const communityId = invitationToken ? path?.split('/').pop() : undefined;

  const headerButtons: HeaderItem[] = [
    {
      label: 'Log in',
      async onClick() {
        await onNavigateToPrimaryLogin();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <AxiosErrorBoundary>
          <GoogleReCaptchaProvider>
            <SignUp
              changeRequestId={changeRequestId}
              communityId={communityId}
              invitationToken={invitationToken}
              onLoginError={onNavigateToPrimaryLogin}
              onNavigateToCheckCode={onNavigateToCheckCode}
              onSuccessLogin={onSuccessSignUp}
              publicCommunityId={state?.join_community_id}
            />
          </GoogleReCaptchaProvider>
        </AxiosErrorBoundary>
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PageSignUp;
